module.exports = __webpack_public_path__ + "img/star.2baafb34.svg";